import { ActionCreator } from 'helper/redux';
import { Account, AccountProfileForm, TempAccount } from 'models/account';
import { Thunk } from 'models/redux';

export * from 'actions/account/email';
export * from 'actions/account/forgotPassword';
export * from 'actions/account/login';
export * from 'actions/account/password';
export * from 'actions/account/phone';
export * from 'actions/account/profile';
export * from 'actions/account/register';
export * from 'actions/account/store';

export const AccountActionCreators = {
  setIsAuthenticated: new ActionCreator<'account/SetIsAuthenticated', void>('account/SetIsAuthenticated'),
  updateAccount: new ActionCreator<'account/UpdateAccount', Account>('account/UpdateAccount'),
  updateTempAccount: new ActionCreator<'account/UpdateTempAccount', TempAccount>('account/UpdateTempAccount'),
  updateTempAccountProfileForm: new ActionCreator<'account/UpdateTempAccountProfileForm', AccountProfileForm>('account/UpdateTempAccountProfileForm')
};

export function resetTempAccount(): Thunk {
  return (dispatch) => {
    const tempAccount: TempAccount = { email: '', password: '', phone: '' };
    dispatch(AccountActionCreators.updateTempAccount.create(tempAccount));
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/account/index.ts